
import frenchMessages from 'ra-language-french';
import specific from '../../config/i18n/fr.json';

const frMessages = {
    ...frenchMessages,
    ...specific,
};

export default frMessages;